import React from 'react';
import WhiteLabelingApp from 'hellosign/components/api/white-labeling';

export default function Page() {
  return <WhiteLabelingApp />;
}
